/* mc-nav.js — state classes for the full-screen mobile menu (assets/mc-nav.css).
   MC 2026-10-04 (Claude, "3.37").

   The theme's drawer script (Slideout, in theme.min.js) keeps #theme-menu
   "open" for 350ms after a close is requested — it was waiting for the old
   drawer to slide away — and it exposes no hook for the start of a close. The
   one thing it does change at that exact moment is the page panel: #main-body
   gets style.position = "fixed" in its beforeopen handler and has it cleared
   again in beforeclose. Watching that single attribute gives an open/closed
   signal that covers every way the menu can close (the X, the sticky header
   button, the theme closing it on resize), without touching the theme script.

   html.mc-nav-js      this script is running (CSS drops its slower fallback)
   html.mc-nav-open    menu is open; removed the moment a close starts
   html.mc-nav-active  open, or still animating shut */
(function () {
  'use strict';
  var html = document.documentElement;
  var panel = null;
  var timer = null;

  function sync() {
    var menu = document.getElementById('theme-menu');
    var open = !!(menu && panel.style.position === 'fixed' && !menu.classList.contains('slideout-panel-hidden'));
    if (open === html.classList.contains('mc-nav-open')) return;
    clearTimeout(timer);
    if (open) {
      html.classList.add('mc-nav-active');
      html.classList.add('mc-nav-open');
    } else {
      html.classList.remove('mc-nav-open');
      timer = setTimeout(function () { html.classList.remove('mc-nav-active'); }, 900);
    }
  }

  function init() {
    panel = document.getElementById('main-body');
    if (!panel || !('MutationObserver' in window)) return;
    new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['style'] });
    html.classList.add('mc-nav-js');
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
